<template>
  <div
    class="custom-message-component-row"
    :style="{
      justifyContent,
      alignItems,
      width
    }"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import {
  CustomMessageType,
  CustomMessageRowComponent,
  CustomMessageMainAxisAlignment,
  CustomMessageCrossAxisAlignment,
} from '_c/typings/model/chat/text-node';
import { pushUrl } from '@/business/chat/custom-message-util';
import { defineComponent, computed, PropType, toRaw } from 'vue';

export default defineComponent({
  name: 'CustomMessageRow',
  props: {
    attr: {
      type: Object as PropType<CustomMessageRowComponent>,
      required: true,
    },
  },
  setup(props) {
    const { onClick, mainAxisAlignment, crossAxisAlignment, children, reportData } = toRaw(props.attr);
    const justifyContent = mainAxisAlignment ?? CustomMessageMainAxisAlignment.center;
    const alignItems = crossAxisAlignment ?? CustomMessageCrossAxisAlignment.start;
    const width = computed(() => {
      let width = '';
      if (children) {
        children.forEach((item) => {
          if (
            item.type === CustomMessageType.Expanded
          || item.type === CustomMessageType.Spacer
          ) {
            width = '100%';
          }
        });
      }
      return width;
    });
    function clickHandle(e: Event): void {
      if (onClick) {
        e.stopPropagation();
        pushUrl(onClick, reportData);
      }
    }

    return {
      clickHandle, width, alignItems, justifyContent,
    };
  },

});


</script>

<style scoped lang="scss">
.custom-message-component-row{
  display: flex;
  flex-direction: row;
}
</style>
